<template>
  <div class="auth-wrapper auth-v2 d-flex align-center justify-center">
    <div class="auth-inner">
      <v-card
        class="pa-6 mx-auto"
        flat
        max-width="420"
      >
        <v-card-title class="text-h5 font-weight-bold mb-4 text-center">
          Verificação em Duas Etapas
        </v-card-title>

        <v-card-subtitle class="mb-6 text-center">
          Enviamos um código de verificação para seu e-mail.<br />
          Insira-o abaixo para continuar.
        </v-card-subtitle>

        <v-form
          ref="mfaForm"
          @submit.prevent="handleVerifyMfa"
        >
          <div class="otp-container">
            <v-text-field
              v-for="(digit, index) in codeDigits"
              :key="index"
              v-model="codeDigits[index]"
              outlined
              maxlength="1"
              hide-details
              type="tel"
              class="otp-digit"
              @input="onInput(index)"
              @keydown.backspace="onBackspace(index, $event)"
            />
          </div>

          <v-btn
            block
            color="primary"
            type="submit"
            :disabled="loading"
            class="mt-6"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              size="20"
              color="white"
            />
            <span v-else>Verificar</span>
          </v-btn>

          <div class="text-center mt-3">
            <span>Não recebeu o código? </span>
            <v-btn
              text
              small
              :disabled="loading"
              class="resend-btn"
              @click="reenviarCodigo"
            >
              Reenviar
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import Vue from 'vue'
import AuthService from '@/services/modules/AuthService'
import router from '@/router'
import useLocalStorage from '@/composables/useLocalStorage'
import useAuthStore from '@/store/auth'

export default {
  setup() {
    const codeDigits = ref(Array(6).fill(''))
    const loading = ref(false)
    const mfaForm = ref(null)

    const authStore = useAuthStore()
    const email = authStore.mfaEmail
    const senha = authStore.mfaPassword
    const provider = 'email'

    function onInput(index) {
      if (codeDigits.value[index].length > 1) {
        codeDigits.value[index] = codeDigits.value[index].slice(-1)
      }
      if (codeDigits.value[index] && index < 5) {
        const nextInput = document.querySelectorAll('.otp-digit input')[index + 1]
        if (nextInput) nextInput.focus()
      }
    }

    function onBackspace(index, event) {
      if (event.key === 'Backspace' && codeDigits.value[index] === '' && index > 0) {
        const prevInput = document.querySelectorAll('.otp-digit input')[index - 1]
        if (prevInput) prevInput.focus()
      }
    }

    async function handleVerifyMfa() {
      const code = codeDigits.value.join('')
      if (code.length !== 6) {
        Vue.$toast.error('Por favor, preencha o código completo.')
        return
      }

      try {
        loading.value = true

        const response = await AuthService.loginMfa({ email, password: senha, provider, code })

        authStore.clearMfaCredentials()

        await useLocalStorage(response.token)

        router.push('/')
      } finally {
        loading.value = false
      }
    }

    async function reenviarCodigo() {
      try {
        loading.value = true
        await AuthService.enviarEmailMfa({ email, password: senha })
        Vue.$toast.success('Código reenviado com sucesso!')
      } catch {
        Vue.$toast.error('Erro ao reenviar código.')
      } finally {
        loading.value = false
      }
    }

    return {
      codeDigits,
      loading,
      mfaForm,
      handleVerifyMfa,
      reenviarCodigo,
      onInput,
      onBackspace,
    }
  },
}
</script>

<style scoped>
.auth-wrapper {
  height: 100vh;
}

.auth-inner {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.otp-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 20px 0;
}

.otp-digit {
  width: 45px;
}

.otp-digit input {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
}

.resend-btn {
  color: #7367f0;
  text-transform: none;
}
</style>
